import { render, staticRenderFns } from "./InputCheckBoxGroup.vue?vue&type=template&id=4ef6480e&"
import script from "./InputCheckBoxGroup.vue?vue&type=script&lang=js&"
export * from "./InputCheckBoxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports